export const environment = {
  idealModalWidth: window.innerWidth > 768 ? '40vw' : '70vw',
  ssoUrl: 'https://sso-dev-frontend.secureid-digital.com.ng',
  appDetails: {
    ClientId: 'DoorToDoor_API',
    ClientSecret:
      'IbE4G3P3vaFgxFD7RGKpmiA/Nlv10el+LIcnSBJu4PlQasWt7MPVcVTNMbEFSFtU',
    GrantType: 'client_credentials',
  },
  baseAPI: 'https://d2d-dev-backend.secureid-digital.com.ng/api',
  ssoBaseAPI: 'https://sso-idserver-dev.secureid-digital.com.ng/api',
  alsBaseAPI: 'https://account-linking-service-dev.secureid-digital.com.ng/api',
  version: 'v1.0.0',
  engageKey: 'pk_00b5f72639bc045bdee1e65df065f99c',
  d2dBaseAPI: 'https://d2d-dev-backend.secureid-digital.com.ng/api',
};
 